export default "__VITE_ASSET__CcOWsgyN__"